import { useState } from 'react'
import { Button, ButtonGroup, Wrapper } from '@farewill/ui'
import { useDispatch } from 'react-redux'

import { hideModal } from 'state/actions'

export const ConfirmModal = ({
  children: textContent,
  onConfirm,
  confirmButtonText = 'Confirm',
  confirmButtonSubmittingText = 'Confirming...',
}: {
  children: React.ReactNode
  onConfirm: () => Promise<void>
  confirmButtonText?: string
  confirmButtonSubmittingText?: string
}) => {
  const dispatch = useDispatch()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleClick = async () => {
    setIsSubmitting(true)

    try {
      await onConfirm()
      dispatch(hideModal())
    } catch {
      setIsSubmitting(false)
    }
  }

  return (
    <Wrapper role="dialog">
      {textContent}
      <ButtonGroup horizontal gap="S">
        <Button.Primary
          type="button"
          onClick={handleClick}
          loading={isSubmitting}
        >
          {isSubmitting ? confirmButtonSubmittingText : confirmButtonText}
        </Button.Primary>
        <Button.Underline type="button" onClick={() => dispatch(hideModal())}>
          Cancel
        </Button.Underline>
      </ButtonGroup>
    </Wrapper>
  )
}
